module.exports = __webpack_public_path__ + "static/static-cbc762077bfde0b3ed255e92e8483520.gif";